import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SalesRepForm from "./SalesRepForm";

function ViewSalesRep() {
  const navigate = useNavigate();
  const location = useLocation();
  const { salesRep } = location.state || {};

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    branch: "QC", // Default branch
    user_update: "admin", // For now, default to admin (this can be dynamic)
  });

  const [isLoading, setIsLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (salesRep) {
      setFormData({
        firstname: salesRep.firstname || "",
        lastname: salesRep.lastname || "",
        branch: salesRep.branch || "QC",
        user_update: "admin",
      });
      setIsLoading(false);
    } else {
      navigate("/not-found");
      setIsLoading(false);
    }
  }, [salesRep, navigate]);

  return (
    <SalesRepForm
      initialValues={formData}
      setFormData={setFormData}
      handleSubmit={() => {}}
      isLoading={isLoading}
      errors={{}}
      successMessage={successMessage}
      setSuccessMessage={setSuccessMessage}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      isView={true}
    />
  );
}

export default ViewSalesRep;
